export const FETCH_AGENT_KEY_STATUS =
  'entry-access/management/keys-with-agent/agent/key/status';
export const FETCH_HOUSE_ENTRY_ACCESS = 'house/:houseId/agent/entry-access';
export const FETCH_KEYS_WITH_AGENT =
  '/entry-access/management/agent/keys-with-agent';
